import { render, staticRenderFns } from "./BrokenLinks.vue?vue&type=template&id=9dba0fda&"
import script from "./BrokenLinks.vue?vue&type=script&lang=js&"
export * from "./BrokenLinks.vue?vue&type=script&lang=js&"
import style0 from "./BrokenLinks.vue?vue&type=style&index=0&id=9dba0fda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports